module.exports = __webpack_public_path__ + "img/settings.bc6481e1.svg";